import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  modalContainer: {
    height: 0,
  },
  modal: {
    justifyContent: 'flex-end',
    margin: 0,
  },
  main: theme => ({
    backgroundColor: theme.colors.backgroundColor,
    overflow: 'hidden',
  }),
  main_normal: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
  },
  main_full: {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    flex: 1,
  },
  content: {
    flexGrow: 1,
  },
})

export default styles
